// English messages, split out of `index.jsx` so `main.jsx` can import just
// this (small) module eagerly instead of the full locale-loader module.
//
// English is the app's default locale, and every `defineMessages()`
// descriptor throughout the app already carries its own `id` AND
// `defaultMessage` (see `@formatjs/intl`'s `formatMessage` — `defineMessages`/
// `defineMessage` are pure identity passthroughs, they don't register
// anything in a global registry). `IntlProvider`'s `messages` map is only
// consulted to *override* a descriptor's `defaultMessage` with a translation;
// when no entry is found for an `id`, `formatMessage` falls back to
// `descriptor.defaultMessage` verbatim, and — critically — does this silently
// (no warning) whenever `locale === defaultLocale`, which is exactly the
// English case. See `index.jsx` for the fuller history of this file.
import { messages as sharedMessagesEn } from './shared.messages.en.js'

// Flattens a `defineMessages()` catalog into the `id -> string` shape
// `IntlProvider`'s `messages` map is keyed by.
const toMessagesById = (catalog) => {
    const messagesById = {}
    for (const message of Object.values(catalog)) {
        if (message && message.id && message.defaultMessage) {
            messagesById[message.id] = message.defaultMessage
        }
    }
    return messagesById
}

const sharedMessagesEnById = toMessagesById(sharedMessagesEn)

export const enMessagesFinal = {
    ...sharedMessagesEn,
    ...sharedMessagesEnById,
}

export default enMessagesFinal
